class OrderDownload
{

   static SELECTOR = '[data-btn-order-download]';
   static API_BASE_URL = 'https://clorofillamusic.streamify.cloud';
   static TOKEN = '0d4a5152516b4cc18177ba66f72413ca';

   constructor(order_id)
   {
      this.order_id = order_id;
      this.loading = false;
      this.setListeners();
   }

   setLoading(loading)
   {
      this.loading = loading;
   }

   setListeners = () =>
   {
      const download_button = document.querySelector(OrderDownload.SELECTOR);
      if( ! download_button )
      {
         return;
      }
      download_button.addEventListener('click', function(event){
         this.handleDownload(event.target);
      }.bind(this));

      console.log(this.order_id);
   }

   handleDownload = async (button_element) => {

      if( this.loading )
      {
         return;
      }

      this.setLoading(true);

      button_element.classList.add('downloading');

      try{

         const response = await fetch(`${OrderDownload.API_BASE_URL}/api/gdrive/orders/${this.order_id}/email/`, {
            method: 'POST',
            headers: {
               'Authorization': `Token ${OrderDownload.TOKEN}`
            }
         });

         if( ! response.ok )
         {
            throw new Error(response.statusText);
         }

         const res = await response.json();

         if( res?.result !== 'OK' )
         {
            throw new Error(res?.message);
         }

         alert('Ti abbiamo inviato una e-mail con le istruzioni per il download dei tuoi acquisti.');
         
      }catch(error)
      {
         alert(error.message);
      }finally
      {
         this.setLoading(false);
         button_element.classList.remove('downloading');
      }

   }
}